import type { ComponentType } from 'react'
import {
  PERMISSION_ENTITY_INVOICE,
  PERMISSION_ENTITY_OPERATIONAL,
  PERMISSION_ENTITY_PROOF_OF_ACCEPTANCE,
  PERMISSION_ENTITY_PURCHASE_ORDER
} from '@klear/constants'
import type { OrderEventType } from '@klear/order-event/constants'
import type { EventFormHandlerProps } from '@klear/order-event-ui/event-shared/event-form-shell'
import { PurchaseOrderEventForm } from '@klear/order-event-ui/event-handlers/PurchaseOrderEventForm'
import { OperationalEventForm } from '@klear/order-event-ui/event-handlers/OperationalEventForm'
import { InvoiceEventForm } from '@klear/order-event-ui/event-handlers/InvoiceEventForm'
import { ProofOfAcceptanceEventForm } from '@klear/order-event-ui/event-handlers/ProofOfAcceptanceEventForm'

const EVENT_FORM_HANDLERS: Partial<Record<OrderEventType, ComponentType<EventFormHandlerProps>>> = {
  [PERMISSION_ENTITY_PURCHASE_ORDER]: PurchaseOrderEventForm,
  [PERMISSION_ENTITY_OPERATIONAL]: OperationalEventForm,
  [PERMISSION_ENTITY_INVOICE]: InvoiceEventForm,
  [PERMISSION_ENTITY_PROOF_OF_ACCEPTANCE]: ProofOfAcceptanceEventForm
}

export function getEventFormHandler(eventType: OrderEventType): ComponentType<EventFormHandlerProps> | null {
  return EVENT_FORM_HANDLERS[eventType] ?? null
}

export function hasEventFormHandler(eventType: string): boolean {
  return eventType in EVENT_FORM_HANDLERS
}
